module.exports = __webpack_public_path__ + "img/28.cff5e004.svg";